module.exports = __webpack_public_path__ + "img/background-pattern.2c909649.svg";